<template>
  <div
    v-show="visible"
    :class="{ 'video-nav-next': true, 'video-nav-next-centered': centered }"
  >
    <a
      class="btn-nav-video"
      @click="onClick"
      :style="($theme.darkTheme ? '' : 'color: #717171; background: #e8e8e8')"
      

    >Próximo
    <IconNext />
    </a>
    <div
      id="video-nav-details-next"
      v-show="hasPreview"
      @click="onClick"
      :style="visible ? 'cursor:pointer;' : 'cursor:default'"
    >
      <img class="nav-details-img" :src="previewImage + '?h=70'" alt />
      <div class="nav-details-name truncate">
        <!-- <small> Próximo conteúdo </small> -->
        {{ previewTitle }}
      </div>
    </div>
  </div>
</template>

<script>
import IconNext from "@/components/UI/IconNext";
export default {
  name: 'NavNextBt',
  props: {
    visible: Boolean,
    onClick: Function,
    centered: Boolean,
    hasPreview: Boolean,
    previewImage: String,
    previewTitle: String
  },
  components: {
    IconNext
  }
};
</script>

<style scoped>
  .video-nav-next-centered {
    top: 50%;
    transform: translateY(-50%);
    right: -14%;
  }
</style>
